import styled, { css } from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    BORDER_PROPERTIES,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

const RESET_STYLES = css`
    border: none;
    outline-style: none;
    font: inherit;
    background: none;
    cursor: pointer;

    &:focus {
        outline-style: auto;
    }
`;

export const DefaultButtonComponent = styled.a`
    ${RESET_STYLES}

    display: inline-block;
    padding: 1rem 2rem;
    border-style: solid;
    background-color: ${(props) => props.$backgroundColor};
    word-break: break-word;

    ${FONT_PROPERTIES}
    ${BORDER_PROPERTIES}

    &:hover {
        background-color: ${(props) => props.$backgroundColorHover};
        color: ${(props) => props.$fontColorHover};
        border-color: ${(props) => props.$borderColorHover};
    }

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
